import format from 'date-fns/format';

const tzRegEx = new RegExp(/\(.*\)/gim);

export const getTZ = (date: Date): string => {
  const matches = date.toString().match(tzRegEx);
  if (!matches || !matches.length) {
    return 'nope';
  }

  const tz = matches[0].replace('(', '').replace(')', '');

  return tz
    .split(' ')
    .map((word) => word.charAt(0))
    .join('');
};

export const formatDate = (date: any) => (date ? format(new Date(date), 'M/d/yyyy h:mm a') : date);

export const formatDateOnly = (date: any) => (date ? format(new Date(date), 'M/d/yyyy') : date);
